import { DataService } from "@/services/data";

// Fonction utilitaire générique pour parser un template et récupérer les variables nécessaires
export async function buildObjectTitleFromTemplate(template: string, objectId: string | number, endpoint: string): Promise<string> {
    if (!template) return "";
    const variables: string[] = Array.from(template.matchAll(/\{(\w+)\}/g)).map((m: RegExpMatchArray) => m[1]);
    if (variables.length === 0) return template;
    const data: Record<string, any> = await DataService.client
        .url(`${endpoint}${objectId}/?fields=${variables.join(",")}`)
        .get()
        .json();
    return template.replace(/\{(\w+)\}/g, (_: string, key: string) => data[key] ?? "");
}
